<script setup lang="ts">
import { Search } from '@element-plus/icons-vue'
import { ref } from 'vue'
import { watchDebounced } from '@vueuse/core'

interface ISearchSettings {
  key: string
  value: string
  type: string
  placeholder: string
  style?: string
  onChange: (value: string) => void
}

const searchVal = ref<string>('')
const props = withDefaults(defineProps<{ searchSettings: ISearchSettings; disabled?: boolean }>(), { disabled: false })

watchDebounced(
  searchVal,
  (value) => {
    props.searchSettings.onChange(value)
  },
  { debounce: 750 }
)
</script>

<template>
  <div class="table-filters">
    <el-input
      v-model="searchVal"
      class="table-filters__search"
      :placeholder="searchSettings.placeholder"
      clearable
      :prefix-icon="Search"
      :style="props.searchSettings.style"
      :disabled="props.disabled"
    />
  </div>
</template>

<style scoped lang="scss">
.table-filters {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &__search {
    width: 200px;
  }
}
</style>
